import axios from 'axios'
// eslint-disable-next-line no-unused-vars
import { web } from '@/config'

import localForage from 'localforage'

const api = `/api/grids/tree`
// const api = `${web}/gridTest.json` // 测试用

// const defaultStorage = sessionStorage
// const defaultStorage = localStorage
const defaultStorage = localForage

const getCache = async (key) => {
  const constructorName = defaultStorage.constructor.name
  if (constructorName === 'Storage') return JSON.parse(defaultStorage.getItem(key))
  return await defaultStorage.getItem(key)
}

const setCache = async (key, value) => {
  const constructorName = defaultStorage.constructor.name
  if (constructorName === 'Storage') return defaultStorage.setItem(key, JSON.stringify(value))
  return await defaultStorage.setItem(key, value)
}

const gridResolve = (arr, map, divide) => {
  arr.forEach(item => {
    const length = String(item.key).length
    item.deep = length
    divide[length].push({ ...item, children: null })
    map[item.key] = item.value
    if (item.children && item.children.length > 0) {
      gridResolve(item.children, map, divide)
    }
  })
}

const state = {
  gridInit: false,
  gridMap: {},
  gridTree: [],
  gridDivide: { 4: [], 6: [], 9: [], 12: [], 14: [] }
}

const mutations = {
  gridInit (state, payload) {
    state.gridInit = payload
  },
  gridMap (state, payload) {
    state.gridMap = payload
  },
  gridTree (state, payload) {
    state.gridTree = payload
  },
  gridDivide (state, payload) {
    state.gridDivide = payload
  }
}

const actions = {
  async getGridMap (content) {
    if (content.state.gridInit) return
    content.commit('gridInit', true)
    // 获取网格信息
    let map = await getCache(`JGridCtrl_MAP_METADATA`)
    let meta = await getCache(`JGridCtrl_METADATA`)
    let divide = await getCache(`JGridCtrl_DIVIDE_METADATA`)
    if (meta && map && divide) { // 本地接口缓存
      content.commit('gridTree', meta)
      content.commit('gridMap', map)
      content.commit('gridDivide', divide)
      return
    }
    map = {}
    divide = { 4: [], 6: [], 9: [], 12: [], 14: [] }
    const { data } = await axios.get(api).catch(error => { console.error(`${api}接口，网格信息获取异常`,error.response) })
    if (data.status != 'yes') return console.error(`${api}接口，网格信息获取异常`)
    let tree = data.data
    if (!Array.isArray(data.data)) {
      tree = [ data.data ]
    }
    gridResolve(tree, map, divide)
    setCache(`JGridCtrl_METADATA`, tree)
    setCache(`JGridCtrl_MAP_METADATA`, map)
    setCache(`JGridCtrl_DIVIDE_METADATA`, divide)
    content.commit('gridTree', tree)
    content.commit('gridMap', map)
    content.commit('gridDivide', divide)
  }
}

// 模块方式注册
export const JGridCtrl = {
  namespaced: true,
  state,
  mutations,
  actions
}
